import { inject, Pipe, PipeTransform } from "@angular/core";
import { AttachmentV2 } from "src/app/backend/models/attachment/attachment";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";

@Pipe({
  name: "attachmentIsSignable",
  standalone: false
})
export class AttachmentIsSignablePipe implements PipeTransform {
  private readonly bootstrapService = inject(BootstrapService);

  transform(attachment: AttachmentV2): boolean {
    if (
      !this.bootstrapService.getCurrentOrganizationConfiguration()?.signature
        ?.type
    ) {
      return false;
    }

    return !!attachment.signable;
  }
}
